import { useRef, useEffect } from 'react';
import gsap from 'gsap';

//* HOC's
import { withLanguageContext } from '@/context';

//* Helpers
import { useActiveSection } from '@/helpers';

//* Components
import CustomLink from '@/components/common/CustomLink';
import Image from '@/components/common/Image';
import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useGSAP } from '@gsap/react';

const BlogItem = ({ index, slug, date, featured_image, reading_time, author, title, short_description, translate }) => {
	//! Refs
	const itemRef = useRef();
	const activeItem = useActiveSection(itemRef);

	const bookmarkRef = useRef();
	const countRef = useRef();
	const titleRef = useRef();
	const descriptionRef = useRef();
	const readTimeRef = useRef();
	const authorWrapRef = useRef();
	const imageRef = useRef();

	// useEffect(() => {
	// 	if (activeItem) {
	// 		gsap.to(imageRef.current, { scale: 1, ease: 'bounce.out', duration: 1.5 });
	// 		gsap.to([bookmarkRef.current, countRef.current, titleRef.current, descriptionRef.current, readTimeRef.current, authorWrapRef.current], { y: 0, opacity: 1, stagger: 0.1 });
	// 	}
	// }, [activeItem]);

	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger);

		if (index === 0) {
			gsap.to(imageRef.current, {
				scale: 1,
				ease: 'bounce.out',
				duration: 1.5,
			});
			gsap.to([bookmarkRef.current, countRef.current, titleRef.current, descriptionRef.current, readTimeRef.current, authorWrapRef.current], {
				y: 0,
				opacity: 1,
				stagger: 0.1,
			});
		} else {
			gsap.to(imageRef.current, {
				scrollTrigger: {
					trigger: bookmarkRef.current,
					// markers: true,
					end: 'top 0%',
					start: 'top 70%',
				},
				scale: 1,
				ease: 'bounce.out',
				duration: 1.5,
			});
			gsap.to([bookmarkRef.current, countRef.current, titleRef.current, descriptionRef.current, readTimeRef.current, authorWrapRef.current], {
				scrollTrigger: {
					trigger: bookmarkRef.current,
					// markers: true,
					end: 'top 0%',
					start: 'top 70%',
				},
				y: 0,
				opacity: 1,
				stagger: 0.1,
			});
		}
		return () => {
			ScrollTrigger.getAll().forEach((trigger) => {
				trigger.kill();
			});
		};
	}, [bookmarkRef.current, countRef.current, titleRef.current, descriptionRef.current, readTimeRef.current, authorWrapRef.current]);

	return (
		<CustomLink
			ref={itemRef}
			className={`blog-item ${index === 0 ? 'first' : ''} `}
			url={slug}
			key={index}>
			<div
				className='bookmark'
				ref={bookmarkRef}>
				<Text className={'h5 font-futura-medium purple'}>{date}</Text>
			</div>
			<Image
				ref={imageRef}
				className={'blog-image'}
				src={featured_image.src}
				alt={featured_image.alt}
			/>
			<div className='content'>
				{index === 0 && (
					<Text
						ref={countRef}
						className={'h1 font-futura-light count'}
						text={String(index + 1).padStart(2, 0)}
					/>
				)}
				{index === 0 ? (
					<Text
						ref={titleRef}
						className={`h1 font-futura-light title`}
						text={title}
					/>
				) : (
					<Text
						ref={titleRef}
						className={`h2 font-futura-medium blog-title`}
						text={title}
					/>
				)}
				{index === 0 && (
					<Text
						ref={descriptionRef}
						className={'h3 font-futura-regular description'}
						text={short_description}
					/>
				)}
				<div
					className='read-time'
					ref={readTimeRef}>
					<Icon
						className={'h5 purple'}
						name={'time'}
					/>
					<Text
						className={'h4 font-futura-regular'}
						text={reading_time}
					/>
				</div>
				<div
					className='author-explore-wrap'
					ref={authorWrapRef}>
					<Text
						className={'h5 font-futura-regular darkGrey'}
						text={`${translate('by')}: ${author}`}
					/>
					<Text
						className={'h5 font-futura-semibold purple underline'}
						text={index === 0 ? 'exploreMore' : 'more'}
					/>
				</div>
			</div>
		</CustomLink>
	);
};

export default withLanguageContext(BlogItem, ['translate']);
